import { StateContext } from '@ngxs/store';
import { ExhibitionStateModel } from '../exhibition.state';
import { ChangeThumbnail } from '../exhibition.state.actions';

export const changeThumbnail = (ctx: StateContext<ExhibitionStateModel>, action: ChangeThumbnail) => {
    ctx.patchState({
        thumbnail: action.payload.thumbnail
    });
};
